var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('static-how-it-works'),_c('static-footer',{attrs:{"pageObj":_vm.howItWorks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }